import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Plus, BookOpen } from 'lucide-react';
import { Button } from '@brainsway/ui';

interface QuickActionsProps {
  pendingCount: number;
  approvedCount: number;
}

export function QuickActions({ pendingCount, approvedCount }: QuickActionsProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-wrap items-center gap-3">
      <Button onClick={() => navigate('/reports/new')} size="sm" className="gap-1.5">
        <Plus className="h-4 w-4" />
        {t('dashboard.newTreatment')}
      </Button>
      <Button onClick={() => navigate('/reports/new')} variant="secondary" size="sm" className="gap-1.5">
        <BookOpen className="h-4 w-4" />
        {t('dashboard.newTeaching')}
      </Button>

      <div className="ms-auto flex gap-3 text-xs">
        {pendingCount > 0 && (
          <span className="rounded-full border border-amber-300 bg-amber-50 px-2.5 py-1 font-semibold text-amber-700">
            {pendingCount} {t('dashboard.pending')}
          </span>
        )}
        <span className="rounded-full border border-green-300 bg-green-50 px-2.5 py-1 font-semibold text-green-700">
          {approvedCount} {t('dashboard.approvedThisMonth')}
        </span>
      </div>
    </div>
  );
}
